function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAspenlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 895.29 280.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M200.06,61.46s-.95-31.77-39.33-31.77-42.36,20.99-42.36,32.9c0,33.28,49.35,31.29,49.35,43.68,0,3.97-3.97,5.11-7.56,5.11-8.32,0-8.89-10.02-8.89-10.02l-32.9-.19s-2.65,35.55,40.84,35.55,40.84-28.93,40.84-31.58,3.12-24.77-28.17-31.77c-23.45-5.11-21.18-19.29-14.94-19.29,3.12,0,9.08,1.13,9.08,7.37h34.04Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.95,61.46s-.95-31.77-39.33-31.77-42.36,20.99-42.36,32.9c0,33.28,49.35,31.29,49.35,43.68,0,3.97-3.97,5.11-7.56,5.11-8.32,0-8.89-10.02-8.89-10.02l-32.9-.19s-2.65,35.55,40.84,35.55,40.84-28.93,40.84-31.58,3.12-24.77-28.17-31.77c-23.45-5.11-21.18-19.29-14.94-19.29,3.12,0,9.08,1.13,9.08,7.37h34.04Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.52 29.69 299.52 136.15 366.08 136.15 366.08 109.3 328.64 109.3 328.64 93.98 363.06 93.98 363.06 71.29 329.4 71.29 329.4 56.92 366.08 56.92 366.08 29.69 299.52 29.69",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.11 29.69 376.11 136.15 406.17 136.15 406.17 84.34 441.91 136.15 474.62 136.15 474.62 29.69 442.67 29.69 442.67 84.15 405.79 29.69 376.11 29.69",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.57,65.8c0-23.64-22.69-36.12-34.6-36.12h-52.38v106.46h29.88v-37.82l21.56,37.82h35.55l-22.31-39.33s22.31-7.37,22.31-31.01ZM659.56,76.49h-18.44v-19.48c17.68,0,24.49,1.99,24.49,9.74s-3.31,9.74-6.05,9.74Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 148.44,
    width: 895.29,
    height: 89.18,
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.06,22.31s-17.9,19.76-17.9,47.02,20.17,44,20.17,44c0,0,9.2-7.06,9.2-51.31,13.61,15.32-.57,96.44-63.35,96.44s-71.86-27.04-71.86-27.04c0,0,18.72,37.06,72.23,37.06s79.73-53.32,79.73-84.34c0-38.01-28.24-61.83-28.24-61.83Z",
    style: {
      fill: "#599541",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.89,18.72S841.26,0,812.24,0s-84.8,24.2-84.8,89.25c0,13.61,7,26.47,7,26.47v-26.28c0-40.28,44.61-79.99,77.8-79.99,38.11,0,49.65,9.27,49.65,9.27Z",
    style: {
      fill: "#e7b774",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.23,82.07h-16.64v55.4s11.16,9.45,16.64,8.7v-64.1Z",
    style: {
      fill: "#599541",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.65,59.75v90.58s7.19,4.73,16.26,3.4V59.75h-16.26Z",
    style: {
      fill: "#599541",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.31,41.98v111.19s12.51-.37,16.67-4.72V41.98h-16.67Z",
    style: {
      fill: "#599541",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.3,200.18c0,4.42-1.5,7.82-4.51,10.18s-7.38,3.54-13.11,3.54H6v-47.22h16.82c5.03,0,8.98,1.07,11.85,3.22s4.32,5.09,4.32,8.83c0,4.55-2.27,7.92-6.8,10.11,3.05.77,5.33,2.2,6.85,4.27s2.27,4.43,2.27,7.07ZM12.25,186.46h10.5c3.46,0,6-.55,7.63-1.66s2.45-2.95,2.45-5.52c0-2.32-.79-4.07-2.38-5.23s-4.35-1.76-8.28-1.76h-9.92v14.17ZM12.25,208.3h11.37c7.47,0,11.21-2.71,11.21-8.12,0-2.81-.86-4.87-2.59-6.17s-4.87-1.95-9.42-1.95h-10.57v16.24Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.52,214.71c-5.48,0-9.57-1.06-12.29-3.19s-4.43-4.63-5.15-7.51-1.08-6.22-1.08-10.02v-27.32h6.25v27.22c0,6.21,1.04,10.29,3.12,12.24s5.13,2.93,9.15,2.93,7.07-.98,9.15-2.93,3.12-6.03,3.12-12.24v-27.22h6.28v27.32c0,5.71-.68,9.92-2.05,12.63s-3.42,4.73-6.17,6.07-6.2,2.01-10.34,2.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.46,214.71c-6.66,0-11.63-1.49-14.93-4.48s-5.03-6.82-5.2-11.5h6.02c.32,3.52,1.79,6.13,4.4,7.81s5.76,2.53,9.45,2.53c3.5,0,6.32-.72,8.46-2.16s3.21-3.39,3.21-5.86c0-2.6-1.11-4.49-3.32-5.67s-6.02-2.35-11.42-3.5-9.28-2.74-11.63-4.78-3.53-4.76-3.53-8.15c0-3.82,1.53-6.96,4.59-9.41s7.12-3.67,12.19-3.67c5.33,0,9.62,1.23,12.89,3.7s4.99,5.96,5.19,10.47h-6.09c-.62-5.71-4.53-8.57-11.73-8.57-3.48,0-6.17.65-8.09,1.97s-2.87,3.05-2.87,5.22c0,1.97.77,3.46,2.3,4.45s4.4,1.94,8.6,2.87,7.53,1.84,10,2.74,4.59,2.3,6.35,4.2,2.64,4.45,2.64,7.65c0,4.06-1.62,7.43-4.85,10.11s-7.45,4.03-12.64,4.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.7,213.9h-6.28v-47.22h6.28v47.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.05,213.9h-6.41l-24.74-37.27v37.27h-5.93v-47.22h6.38l24.74,37.27v-37.27h5.96v47.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.83,213.9h-35.21v-47.22h34.11v5.61h-27.86v14.43h26.06v5.61h-26.06v15.98h28.96v5.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.44,214.71c-6.66,0-11.63-1.49-14.93-4.48s-5.03-6.82-5.2-11.5h6.02c.32,3.52,1.79,6.13,4.4,7.81s5.76,2.53,9.45,2.53c3.5,0,6.32-.72,8.46-2.16s3.21-3.39,3.21-5.86c0-2.6-1.11-4.49-3.32-5.67s-6.02-2.35-11.42-3.5-9.28-2.74-11.63-4.78-3.53-4.76-3.53-8.15c0-3.82,1.53-6.96,4.59-9.41s7.12-3.67,12.19-3.67c5.33,0,9.62,1.23,12.89,3.7s4.99,5.96,5.19,10.47h-6.09c-.62-5.71-4.53-8.57-11.73-8.57-3.48,0-6.17.65-8.09,1.97s-2.87,3.05-2.87,5.22c0,1.97.77,3.46,2.3,4.45s4.4,1.94,8.6,2.87,7.53,1.84,10,2.74,4.59,2.3,6.35,4.2,2.64,4.45,2.64,7.65c0,4.06-1.62,7.43-4.85,10.11s-7.45,4.03-12.64,4.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.44,214.71c-6.66,0-11.63-1.49-14.93-4.48s-5.03-6.82-5.2-11.5h6.02c.32,3.52,1.79,6.13,4.4,7.81s5.76,2.53,9.45,2.53c3.5,0,6.32-.72,8.46-2.16s3.21-3.39,3.21-5.86c0-2.6-1.11-4.49-3.32-5.67s-6.02-2.35-11.42-3.5-9.28-2.74-11.63-4.78-3.53-4.76-3.53-8.15c0-3.82,1.53-6.96,4.59-9.41s7.12-3.67,12.19-3.67c5.33,0,9.62,1.23,12.89,3.7,3.26,2.47,4.99,5.96,5.19,10.47h-6.09c-.62-5.71-4.53-8.57-11.73-8.57-3.48,0-6.17.65-8.09,1.97s-2.87,3.05-2.87,5.22c0,1.97.77,3.46,2.3,4.45s4.4,1.94,8.6,2.87,7.53,1.84,10,2.74,4.59,2.3,6.35,4.2,2.64,4.45,2.64,7.65c0,4.06-1.62,7.43-4.85,10.11s-7.45,4.03-12.64,4.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.97,214.71c-6.66,0-11.63-1.49-14.93-4.48s-5.03-6.82-5.2-11.5h6.02c.32,3.52,1.79,6.13,4.4,7.81s5.76,2.53,9.45,2.53c3.5,0,6.32-.72,8.46-2.16s3.21-3.39,3.21-5.86c0-2.6-1.11-4.49-3.32-5.67s-6.02-2.35-11.42-3.5-9.28-2.74-11.63-4.78-3.53-4.76-3.53-8.15c0-3.82,1.53-6.96,4.59-9.41s7.12-3.67,12.19-3.67c5.33,0,9.62,1.23,12.89,3.7s4.99,5.96,5.19,10.47h-6.09c-.62-5.71-4.53-8.57-11.73-8.57-3.48,0-6.17.65-8.09,1.97s-2.87,3.05-2.87,5.22c0,1.97.77,3.46,2.3,4.45s4.4,1.94,8.6,2.87,7.53,1.84,10,2.74,4.59,2.3,6.35,4.2,2.64,4.45,2.64,7.65c0,4.06-1.62,7.43-4.85,10.11s-7.45,4.03-12.64,4.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.61,165.87c6.61,0,12.03,2.23,16.24,6.7,4.21,4.47,6.31,10.37,6.31,17.72s-2.11,13.25-6.31,17.72c-4.21,4.47-9.62,6.7-16.24,6.7s-12.07-2.24-16.3-6.72-6.35-10.38-6.35-17.7,2.11-13.25,6.35-17.72,9.66-6.7,16.3-6.7ZM421.55,209.36c4.72,0,8.6-1.68,11.61-5.03s4.53-8.03,4.53-14.04-1.5-10.69-4.51-14.04-6.84-5.03-11.5-5.03-8.64,1.68-11.68,5.03-4.56,8.03-4.56,14.04,1.51,10.67,4.54,14.03,6.88,5.04,11.56,5.04Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.69,213.9h-29.22v-47.22h6.25v41.62h22.97v5.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.69,214.71c-5.48,0-9.57-1.06-12.29-3.19s-4.43-4.63-5.15-7.51-1.08-6.22-1.08-10.02v-27.32h6.25v27.22c0,6.21,1.04,10.29,3.12,12.24s5.13,2.93,9.15,2.93,7.07-.98,9.15-2.93,3.12-6.03,3.12-12.24v-27.22h6.28v27.32c0,5.71-.68,9.92-2.05,12.63s-3.42,4.73-6.17,6.07-6.2,2.01-10.34,2.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.37,172.28h-15.62v41.62h-6.28v-41.62h-15.49v-5.61h37.4v5.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.16,213.9h-6.28v-47.22h6.28v47.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.89,165.87c6.61,0,12.03,2.23,16.24,6.7s6.31,10.37,6.31,17.72-2.11,13.25-6.31,17.72-9.62,6.7-16.24,6.7-12.07-2.24-16.3-6.72c-4.23-4.48-6.35-10.38-6.35-17.7s2.11-13.25,6.35-17.72c4.23-4.47,9.66-6.7,16.3-6.7ZM615.83,209.36c4.72,0,8.6-1.68,11.61-5.03s4.53-8.03,4.53-14.04-1.5-10.69-4.51-14.04-6.84-5.03-11.5-5.03-8.64,1.68-11.68,5.03-4.56,8.03-4.56,14.04,1.51,10.67,4.54,14.03,6.88,5.04,11.56,5.04Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.83,213.9h-6.41l-24.74-37.27v37.27h-5.93v-47.22h6.38l24.74,37.27v-37.27h5.96v47.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.21,214.71c-6.66,0-11.63-1.49-14.93-4.48s-5.03-6.82-5.2-11.5h6.02c.32,3.52,1.79,6.13,4.4,7.81s5.76,2.53,9.45,2.53c3.5,0,6.32-.72,8.46-2.16s3.21-3.39,3.21-5.86c0-2.6-1.11-4.49-3.32-5.67s-6.02-2.35-11.42-3.5-9.28-2.74-11.63-4.78-3.53-4.76-3.53-8.15c0-3.82,1.53-6.96,4.59-9.41,3.06-2.45,7.12-3.67,12.19-3.67,5.33,0,9.62,1.23,12.89,3.7s4.99,5.96,5.19,10.47h-6.09c-.62-5.71-4.53-8.57-11.73-8.57-3.48,0-6.17.65-8.09,1.97s-2.87,3.05-2.87,5.22c0,1.97.77,3.46,2.3,4.45s4.4,1.94,8.6,2.87,7.53,1.84,10,2.74,4.59,2.3,6.35,4.2,2.64,4.45,2.64,7.65c0,4.06-1.62,7.43-4.85,10.11s-7.45,4.03-12.64,4.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.47,213.9h-29.22v-47.22h6.25v41.62h22.97v5.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.16,213.9h-29.22v-47.22h6.25v41.62h22.97v5.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.41,214.71c-6.68,0-12.01-2.2-15.99-6.59-3.98-4.39-5.98-10.33-5.98-17.83s1.99-13.44,5.98-17.83c3.98-4.39,9.32-6.59,15.99-6.59,5.13,0,9.5,1.39,13.11,4.16s5.64,6.42,6.09,10.95h-6.44c-.26-2.99-1.55-5.36-3.88-7.12-2.33-1.76-5.27-2.64-8.81-2.64-4.79,0-8.58,1.65-11.37,4.94-2.79,3.3-4.19,8-4.19,14.13s1.39,10.8,4.16,14.11,6.53,4.96,11.27,4.96c3.69,0,6.68-.9,8.96-2.71,2.28-1.8,3.57-4.38,3.87-7.73h6.44c-.45,5.03-2.43,8.91-5.93,11.66-3.5,2.75-7.92,4.12-13.27,4.12Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.89,277.36h-3.88l-3.01-7.9h-10.88l-2.87,7.9h-3.63l9.97-25.97h3.7l10.59,25.97ZM38.99,266.73l-4.57-12.05-4.36,12.05h8.93Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26,277.81c-3.67,0-6.61-1.21-8.8-3.62-2.19-2.42-3.29-5.69-3.29-9.81s1.1-7.39,3.29-9.81c2.19-2.42,5.12-3.62,8.8-3.62,2.82,0,5.23.76,7.21,2.28s3.1,3.53,3.35,6.02h-3.54c-.14-1.64-.85-2.95-2.14-3.91-1.28-.97-2.9-1.46-4.84-1.46-2.63,0-4.72.91-6.25,2.72s-2.3,4.4-2.3,7.77.76,5.94,2.29,7.76c1.52,1.82,3.59,2.73,6.2,2.73,2.03,0,3.67-.5,4.93-1.49s1.96-2.41,2.13-4.25h3.54c-.25,2.76-1.34,4.9-3.26,6.42-1.92,1.51-4.36,2.27-7.3,2.27Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.08,277.81c-3.67,0-6.61-1.21-8.8-3.62-2.19-2.42-3.29-5.69-3.29-9.81s1.1-7.39,3.29-9.81c2.19-2.42,5.12-3.62,8.8-3.62,2.82,0,5.23.76,7.21,2.28s3.1,3.53,3.35,6.02h-3.54c-.14-1.64-.85-2.95-2.14-3.91-1.28-.97-2.9-1.46-4.84-1.46-2.63,0-4.72.91-6.25,2.72s-2.3,4.4-2.3,7.77.76,5.94,2.29,7.76c1.52,1.82,3.59,2.73,6.2,2.73,2.03,0,3.67-.5,4.93-1.49s1.96-2.41,2.13-4.25h3.54c-.25,2.76-1.34,4.9-3.26,6.42-1.92,1.51-4.36,2.27-7.3,2.27Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.27,250.95c3.64,0,6.61,1.23,8.93,3.69,2.31,2.45,3.47,5.7,3.47,9.74s-1.16,7.29-3.47,9.75c-2.31,2.45-5.29,3.69-8.93,3.69s-6.64-1.23-8.96-3.69c-2.33-2.46-3.49-5.71-3.49-9.74s1.16-7.29,3.49-9.74c2.33-2.46,5.32-3.69,8.96-3.69ZM115.24,274.86c2.6,0,4.73-.92,6.39-2.76,1.66-1.84,2.49-4.42,2.49-7.72s-.83-5.88-2.48-7.72-3.76-2.76-6.33-2.76-4.75.92-6.42,2.76c-1.67,1.84-2.51,4.42-2.51,7.72s.83,5.87,2.5,7.72,3.79,2.77,6.36,2.77Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.05,277.81c-3.01,0-5.27-.59-6.76-1.76-1.49-1.17-2.44-2.54-2.83-4.13-.39-1.58-.59-3.42-.59-5.51v-15.02h3.44v14.97c0,3.41.57,5.66,1.72,6.73,1.15,1.08,2.82,1.61,5.03,1.61s3.89-.54,5.03-1.61c1.15-1.07,1.72-3.32,1.72-6.73v-14.97h3.45v15.02c0,3.14-.38,5.46-1.13,6.95-.75,1.49-1.88,2.6-3.39,3.34s-3.41,1.11-5.69,1.11Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.08,277.36h-3.53l-13.61-20.5v20.5h-3.26v-25.97h3.51l13.61,20.5v-20.5h3.28v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.97,254.47h-8.59v22.89h-3.45v-22.89h-8.52v-3.08h20.57v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.17,277.36h-3.45v-25.97h3.45v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.38,277.36h-3.53l-13.61-20.5v20.5h-3.26v-25.97h3.51l13.61,20.5v-20.5h3.28v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.16,277.81c-3.73,0-6.76-1.22-9.08-3.67-2.32-2.44-3.48-5.7-3.48-9.76s1.15-7.33,3.44-9.77,5.3-3.66,9.02-3.66c3.13,0,5.73.75,7.8,2.26,2.07,1.5,3.23,3.52,3.48,6.05h-3.56c-.14-1.68-.9-2.99-2.27-3.94s-3.18-1.43-5.42-1.43c-2.68,0-4.84.92-6.48,2.75-1.63,1.83-2.45,4.41-2.45,7.74s.83,5.9,2.48,7.73,3.82,2.75,6.48,2.75c8.56,0,8.34-7.65,8.34-7.65h-9.59v-3.1h12.92c0,6.8-3.12,13.7-11.64,13.7Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.34,277.81c-3.73,0-6.76-1.22-9.08-3.67-2.32-2.44-3.48-5.7-3.48-9.76s1.15-7.33,3.44-9.77,5.3-3.66,9.02-3.66c3.13,0,5.73.75,7.8,2.26,2.07,1.5,3.23,3.52,3.48,6.05h-3.56c-.14-1.68-.9-2.99-2.27-3.94s-3.18-1.43-5.42-1.43c-2.68,0-4.84.92-6.48,2.75-1.63,1.83-2.45,4.41-2.45,7.74s.83,5.9,2.48,7.73,3.82,2.75,6.48,2.75c8.56,0,8.34-7.65,8.34-7.65h-9.59v-3.1h12.92c0,6.8-3.12,13.7-11.64,13.7Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.7,277.81c-3.73,0-6.76-1.22-9.08-3.67-2.32-2.44-3.48-5.7-3.48-9.76s1.15-7.33,3.44-9.77,5.3-3.66,9.02-3.66c3.13,0,5.73.75,7.8,2.26,2.07,1.5,3.23,3.52,3.48,6.05h-3.56c-.14-1.68-.9-2.99-2.27-3.94s-3.18-1.43-5.42-1.43c-2.68,0-4.84.92-6.48,2.75-1.63,1.83-2.45,4.41-2.45,7.74s.83,5.9,2.48,7.73,3.82,2.75,6.48,2.75c8.56,0,8.34-7.65,8.34-7.65h-9.59v-3.1h12.92c0,6.8-3.12,13.7-11.64,13.7Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.1,277.81c-3.67,0-6.61-1.21-8.8-3.62-2.19-2.42-3.29-5.69-3.29-9.81s1.1-7.39,3.29-9.81c2.19-2.42,5.12-3.62,8.8-3.62,2.82,0,5.23.76,7.21,2.28s3.1,3.53,3.35,6.02h-3.54c-.14-1.64-.85-2.95-2.14-3.91-1.28-.97-2.9-1.46-4.84-1.46-2.63,0-4.72.91-6.25,2.72s-2.3,4.4-2.3,7.77.76,5.94,2.29,7.76c1.52,1.82,3.59,2.73,6.2,2.73,2.03,0,3.67-.5,4.93-1.49s1.96-2.41,2.13-4.25h3.54c-.25,2.76-1.34,4.9-3.26,6.42-1.92,1.51-4.36,2.27-7.3,2.27Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.24,250.95c3.64,0,6.61,1.23,8.93,3.69,2.31,2.45,3.47,5.7,3.47,9.74s-1.16,7.29-3.47,9.75c-2.31,2.45-5.29,3.69-8.93,3.69s-6.64-1.23-8.96-3.69c-2.33-2.46-3.49-5.71-3.49-9.74s1.16-7.29,3.49-9.74c2.33-2.46,5.32-3.69,8.96-3.69ZM349.21,274.86c2.6,0,4.73-.92,6.39-2.76,1.66-1.84,2.49-4.42,2.49-7.72s-.83-5.88-2.48-7.72-3.76-2.76-6.33-2.76-4.75.92-6.42,2.76c-1.67,1.84-2.51,4.42-2.51,7.72s.83,5.87,2.5,7.72,3.79,2.77,6.36,2.77Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.17,277.36h-3.53l-13.61-20.5v20.5h-3.26v-25.97h3.51l13.61,20.5v-20.5h3.28v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.35,277.81c-3.66,0-6.4-.82-8.21-2.46-1.81-1.64-2.77-3.75-2.86-6.32h3.31c.18,1.94.98,3.37,2.42,4.29,1.44.93,3.17,1.39,5.2,1.39,1.92,0,3.48-.4,4.65-1.19,1.18-.79,1.76-1.87,1.76-3.22,0-1.43-.61-2.47-1.82-3.12-1.22-.65-3.31-1.29-6.28-1.92-2.97-.63-5.1-1.51-6.39-2.63-1.29-1.12-1.94-2.62-1.94-4.48,0-2.1.84-3.83,2.52-5.17,1.68-1.35,3.92-2.02,6.71-2.02,2.93,0,5.29.68,7.09,2.04s2.75,3.28,2.85,5.76h-3.35c-.34-3.14-2.49-4.72-6.45-4.72-1.91,0-3.4.36-4.45,1.08s-1.58,1.68-1.58,2.87c0,1.09.42,1.9,1.27,2.44.85.54,2.42,1.07,4.73,1.58,2.31.51,4.14,1.01,5.5,1.5s2.52,1.27,3.49,2.31c.97,1.04,1.45,2.45,1.45,4.21,0,2.23-.89,4.09-2.67,5.56-1.78,1.48-4.09,2.22-6.95,2.22Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5,277.81c-3.01,0-5.27-.59-6.76-1.76-1.49-1.17-2.44-2.54-2.83-4.13-.39-1.58-.59-3.42-.59-5.51v-15.02h3.44v14.97c0,3.41.57,5.66,1.72,6.73,1.15,1.08,2.82,1.61,5.03,1.61s3.89-.54,5.03-1.61c1.15-1.07,1.72-3.32,1.72-6.73v-14.97h3.45v15.02c0,3.14-.38,5.46-1.13,6.95-.75,1.49-1.88,2.6-3.39,3.34s-3.41,1.11-5.69,1.11Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.15,277.36h-16.07v-25.97h3.44v22.89h12.63v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.29,254.47h-8.59v22.89h-3.45v-22.89h-8.52v-3.08h20.57v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.44,277.36h-3.45v-25.97h3.45v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.6,277.36h-3.53l-13.61-20.5v20.5h-3.26v-25.97h3.51l13.61,20.5v-20.5h3.28v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.52,277.35h-4.87s-4.8-11.1-6.12-11.1h-3.52v11.11h-3.44v-25.97h11.5c2.01,0,3.65.2,4.93.58,1.28.39,2.31,1.21,3.12,2.46s1.2,2.66,1.2,4.24c0,1.79-.52,3.29-1.56,4.5s-2.46,1.99-4.27,2.36l-2.86.06,5.89,11.76ZM614.01,263.17h7.67c2.14,0,3.69-.34,4.65-1.01.96-.67,1.44-1.84,1.44-3.49,0-2.95-1.85-4.43-5.56-4.43h-8.2v8.93Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.46,277.36h-3.88l-3.01-7.9h-10.88l-2.87,7.9h-3.63l9.97-25.97h3.7l10.59,25.97ZM649.56,266.73l-4.57-12.05-4.36,12.05h8.93Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.07,277.36h-3.53l-13.61-20.5v20.5h-3.26v-25.97h3.51l13.61,20.5v-20.5h3.28v25.97Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.69,254.47h-8.59v22.89h-3.45v-22.89h-8.52v-3.08h20.57v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.53,277.81c-3.66,0-6.4-.82-8.21-2.46-1.81-1.64-2.77-3.75-2.86-6.32h3.31c.18,1.94.98,3.37,2.42,4.29,1.44.93,3.17,1.39,5.2,1.39,1.92,0,3.48-.4,4.65-1.19,1.18-.79,1.76-1.87,1.76-3.22,0-1.43-.61-2.47-1.82-3.12-1.22-.65-3.31-1.29-6.28-1.92-2.97-.63-5.1-1.51-6.39-2.63-1.29-1.12-1.94-2.62-1.94-4.48,0-2.1.84-3.83,2.52-5.17,1.68-1.35,3.92-2.02,6.71-2.02,2.93,0,5.29.68,7.09,2.04s2.75,3.28,2.85,5.76h-3.35c-.34-3.14-2.49-4.72-6.45-4.72-1.91,0-3.4.36-4.45,1.08s-1.58,1.68-1.58,2.87c0,1.09.42,1.9,1.27,2.44.85.54,2.42,1.07,4.73,1.58,2.31.51,4.14,1.01,5.5,1.5s2.52,1.27,3.49,2.31c.97,1.04,1.45,2.45,1.45,4.21,0,2.23-.89,4.09-2.67,5.56-1.78,1.48-4.09,2.22-6.95,2.22Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M781.82,254.47h-8.59v22.89h-3.45v-22.89h-8.52v-3.08h20.57v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.07,277.36h-3.88l-3.01-7.9h-10.88l-2.87,7.9h-3.63l9.97-25.97h3.7l10.59,25.97ZM799.17,266.73l-4.57-12.05-4.36,12.05h8.93Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.28,277.36h-4.22l-7.69-11-7.72,11h-4.22l9.97-13.68-8.98-12.3h4.2l6.71,9.6,6.75-9.6h4.2l-9.02,12.3,10.01,13.68Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.94,277.36h-19.36v-25.97h18.76v3.08h-15.32v7.94h14.33v3.08h-14.33v8.79h15.93v3.08Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.8,277.81c-3.66,0-6.4-.82-8.21-2.46-1.81-1.64-2.76-3.75-2.86-6.32h3.31c.18,1.94.98,3.37,2.42,4.29,1.44.93,3.17,1.39,5.2,1.39,1.92,0,3.48-.4,4.65-1.19,1.18-.79,1.77-1.87,1.77-3.22,0-1.43-.61-2.47-1.83-3.12-1.21-.65-3.31-1.29-6.28-1.92-2.97-.63-5.1-1.51-6.39-2.63-1.29-1.12-1.94-2.62-1.94-4.48,0-2.1.84-3.83,2.52-5.17,1.68-1.35,3.92-2.02,6.71-2.02,2.93,0,5.29.68,7.09,2.04,1.8,1.36,2.75,3.28,2.85,5.76h-3.35c-.34-3.14-2.49-4.72-6.45-4.72-1.91,0-3.4.36-4.45,1.08-1.05.72-1.58,1.68-1.58,2.87,0,1.09.42,1.9,1.27,2.44.85.54,2.42,1.07,4.73,1.58,2.31.51,4.14,1.01,5.5,1.5,1.36.5,2.52,1.27,3.49,2.31.97,1.04,1.45,2.45,1.45,4.21,0,2.23-.89,4.09-2.67,5.56-1.77,1.48-4.09,2.22-6.95,2.22Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.74,29.69h-37.63L4.54,136.15h35.55l5.67-17.4h32.33l6.05,17.4h35.17L80.74,29.69ZM51.81,96.72l7.94-29.5h1.37l11.11,29.5h-20.42Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.19,29.69h-52.57v106.46h32.15v-34.6h24.96c6.81,0,27.23-9.45,27.23-34.6s-20.04-37.25-31.77-37.25ZM254.77,77.02h-14.5v-20.17h7.15s12.7,1.95,12.7,10.08-5.36,10.09-5.36,10.09Z",
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.04,
    y: 251.39,
    width: 4.73,
    height: 29.32,
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.34,
    y: 251.39,
    width: 4.73,
    height: 29.32,
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 740.62,
    y: 251.39,
    width: 4.73,
    height: 29.32,
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "748.12 207.3 741.04 207.3 737.84 223.21 740.75 223.21 748.12 207.3",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspenlogo);
export default __webpack_public_path__ + "static/media/aspenlogo.86b9fb73125db73b5f2296b3a219250b.svg";
export { ForwardRef as ReactComponent };